import * as React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import AuthGuard from "./_utilities/AuthGuard";
import { applyTheme } from "./_utilities/themeUtils";
import "./App.css";
import Layout from "./pages/Layout";
import SessionConflictModal from "./components/SessionConflictModal/SessionConflictModal";

// import
// jobposting components
import PostingsDocuments from "./pages/JobPostings/PostingsDocuments/PostingsDocuments";
import PostingsEdit from "./pages/JobPostings/PostingsEdit/PostingsEdit";
import PostingsNotes from "./pages/JobPostings/PostingsNotes/PostingsNotes";
import PostingsTable from "./pages/JobPostings/PostingsTable/PostingsTable";
import PostingsView from "./pages/JobPostings/PostingsView/PostingsView";
// import PostingsCreate from "./pages/JobPostings/PostingsCreate/PostingsCreate";
import PostingsAuditlogging from "./pages/JobPostings/PostingsAuditlogging/PostingsAuditlogging";
import PostingsCreate from "./pages/JobPostings/PostingsCreate/PostingsCreate";
import PostingsCreateTabs from "./pages/JobPostings/PostingsCreate/PostingsCreateTabs";
import JobPortal from "./pages/JobPostings/PostingsJobPortal/JobPortal";
import PostingsPortalsEdit from "./pages/JobPostings/PostingsPortals/PostingsPortalsEdit";
import PostingsPortalsView from "./pages/JobPostings/PostingsPortals/PostingsPortalsView";

import JobpostingList from "./pages/JobPostings_New_UI/JobpostingList/JobpostingList";

// Applicants components
import ApplicantsAssociatedJobs from "./pages/Applicants/ApplicantsAssociatedJobs/ApplicantAssociatedJobs";
import ApplicantsAuditlogging from "./pages/Applicants/ApplicantsAuditlogging/ApplicantsAuditlogging";
import ApplicantsCreate from "./pages/Applicants/ApplicantsCreate/ApplicantsCreate";
import ApplicantsDocuments from "./pages/Applicants/ApplicantsDocuments/ApplicantDocuments";
import ApplicantsEdit from "./pages/Applicants/ApplicantsEdit/ApplicantsEdit";
import ApplicantsNotes from "./pages/Applicants/ApplicantsNotes/ApplicantsNotes";
import ApplicantsTable from "./pages/Applicants/ApplicantsTable/ApplicantsTable";
import ApplicantsViewNew from "./pages/Applicants/ApplicantsView/ApplicantsViewNew";

// user management
import ForgotPassword from "./pages/Landings/ForgotPassword/ForgotPassword";
import Login from "./pages/Landings/LoginForm/Login";
import Register from "./pages/Landings/RegisterForm/Register";
import ResetPassword from "./pages/Landings/ResetPassword/ResetPassword";
import VerifyOTP from "./pages/Landings/VerifyOTP/VerifyOTP";

//Clients Components
import ClientsView from "./pages/Clients/ClentsView/ClientsView";
import ClientsAuditlogging from "./pages/Clients/ClientsAuditlogging/ClientsAuditlogging";
import ClientsCreate from "./pages/Clients/ClientsCreate/ClientsCreate";
import ClientsEdit from "./pages/Clients/ClientsEdit/ClientsEdit";
import ClientsTable from "./pages/Clients/ClientsTable/ClientsTable";
import HiringManagers from "./pages/Clients/HiringManagers/HiringManagers";
import ClientsOverview from "./pages/Clients/ClientsOverview/ClientsOverview";

// HelpSection Component
import HelpSectionApplicants from "./pages/HelpSection/HelpSectionApplicants";
import HelpSectionEmail from "./pages/HelpSection/HelpSectionEmail";
import HelpSectionJobpostings from "./pages/HelpSection/HelpSectionJobpostings";

//Customer
import Billing from "./pages/Customer/Billing/Billing";
import Custom from "./pages/Customer/Custom/Custom";
import CustomerView from "./pages/Customer/CustomerView/CustomerView";
import Mail from "./pages/Customer/Mail/Mail";
import NewJobBoardPortal from "./pages/Customer/NewJobBoardPortal/NewJobBoardPortal";
import User from "./pages/Customer/Users/User";
import VendorPortal from "./pages/Customer/Vendors/VendorPortal";

import ApplicantsNewDahboard from "./pages/Applicants/ApplicantsNewDashboard/ApplicantsNewDahboard";
import Segments from "./pages/Customer/Segments/Segments";
import JobpostingsAssociatedApplicantsProfile from "./pages/JobPostings/PostingsAssociatedApplicantProfile/PostingsAssociatedApplicantsProfile";
import Error404 from "./pages/PageNotFound/Error404";
import PageNotFound from "./pages/PageNotFound/PageNotFound";
import UnsubscribePage from "./pages/PageNotFound/UnsubscribePage";
import RingCentralRedirectionComponent from "./pages/RingCentral/RingCentralRedirction";

import { systemRoles } from "./constants/constants";
import ApplicantsRenderExcelData from "./pages/Applicants/ApplicantsTable/ApplicantsRenderExcelData";
import EndClients from "./pages/Clients/EndClients/EndClients";
import ProjectsAssociatedApplicants from "./pages/Projects/ProjectAssociatedApplicants/ProjectAssociatedApplicants";
import ProjectsAuditlogging from "./pages/Projects/ProjectsAuditlogging/ProjectsAuditlogging";
import ProjectsEdit from "./pages/Projects/ProjectsEdit/ProjectsEdit";
import ProjectsTable from "./pages/Projects/ProjectsTable/ProjectsTable";
import ProjectsView from "./pages/Projects/ProjectsView/ProjectsView";
import ApplicantsList from "./pages/Applicants_New_UI/ApplicantsList/ApplicantsList";
import ApplicantDetailsCreate from "./pages/Applicants_New_UI/ApplicantDetails/ApplicantDetailsCreate/ApplicantDetailsCreate";
import AddJobsToProjects from "./pages/Projects/AddJobsToProjects/AddJobsToProjects";

import ReportsDashboard from "./pages/ReportsDashboard/ReportsDashboard";
import ReportCentre from "./pages/ReportsDashboard/ReportCentre";
import { useSelector } from "react-redux";
import MobileRestriction from "./pages/MobileRestriction/MobileRestriction";
import ClientJobs from "./pages/Clients/ClientJobs/ClientJobs";
import PostingsViewNew from "./pages/JobPostings/PostingsView/PostingsViewNew";
import PostingsDetailView from "./pages/JobPostings/PostingsView/PostingsDetailView";
import ScheduleReportsDashboard from "./pages/ReportsDashboard/ScheduleReportsDashboard";

function App() {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const location = useLocation();
  React.useLayoutEffect(() => {
    const storedTheme = localStorage.getItem("themeSettings");
    if (storedTheme) {
      applyTheme(JSON.parse(storedTheme));
    }
  }, [location]);

  React.useEffect(() => {
    const url = window.location.pathname;
    const path = url.includes("layout");
    if (path) {
      document.body.classList.remove("bg-yellow");
    } else {
      document.body.classList.add("bg-yellow");
    }
  }, [location]);

  const { customerId, systemRole } = useSelector((state) => state.Auth);
  const isAuthenticated = Boolean(customerId);
  const isFieldRecruiter = systemRole === "Field Recruiter";
  const defaultLanding = isFieldRecruiter
    ? "/ats/layout/applicants/list/landing"
    : "/ats/layout/dashboard";

  const AtsRedirect = ({ isAuthenticated }) => {
    return isAuthenticated ? (
      <Navigate to={defaultLanding} replace />
    ) : (
      <Navigate to="/ats/login" replace />
    );
  };

  const restrictedRoles = systemRoles.filter(
    (role) => role !== "Field Recruiter",
  );

  if (isAuthenticated && !isFieldRecruiter && isMobile) {
    return <MobileRestriction />;
  }

  return (
    <>
    <SessionConflictModal />
    <Routes>
      <Route
        exact
        path="/"
        element={
          <Navigate to={defaultLanding.replace("/ats/", "ats/")} replace />
        }
      ></Route>
      <Route
        path="ats/oauth/callback"
        element={<RingCentralRedirectionComponent />}
      />
      <Route
        path="ats"
        element={<AtsRedirect isAuthenticated={customerId} />}
      />
      <Route path="ats/register" element={<Register />} />
      <Route
        path="ats/login"
        element={
          isAuthenticated ? <Navigate to={defaultLanding} replace /> : <Login />
        }
      />
      <Route path="ats/forgotpassword" element={<ForgotPassword />} />
      <Route path="ats/reset-password" element={<ResetPassword />} />
      <Route path="ats/verify-otp" element={<VerifyOTP />} />
      <Route path="ats/unsubscribe/:id" element={<UnsubscribePage />} />

      <Route path="ats/layout" element={<Layout />}>
        <Route element={<AuthGuard allowedRoles={restrictedRoles} />}>
          <Route path="dashboard" element={<ApplicantsNewDahboard />} />
        </Route>
        <Route element={<AuthGuard allowedRoles={restrictedRoles} />}>
          <Route path="applicants/landing" element={<ApplicantsTable />} />
          <Route path="applicants/view/:id" element={<ApplicantsViewNew />} />
          <Route path="applicants/edit/:id" element={<ApplicantsEdit />} />
          <Route path="applicants/notes/:id" element={<ApplicantsNotes />} />
          <Route
            path="applicants/documents/:id"
            element={<ApplicantsDocuments />}
          />
          <Route path="applicants/create" element={<ApplicantsCreate />} />
          <Route
            path="applicants/create-duplicate"
            element={<ApplicantsCreate />}
          />
          <Route
            path="applicants/create-bulk"
            element={<ApplicantsRenderExcelData />}
          />
          <Route
            path="applicants/associatedjobs/:id"
            element={<ApplicantsAssociatedJobs />}
          />
          <Route
            path="applicants/associatedjobs/jobview/:id"
            element={<PostingsView />}
          />
          <Route
            path="applicants/auditinfo/:id"
            element={<ApplicantsAuditlogging />}
          />
          <Route
            path="applicants/create-new-duplicate"
            element={<ApplicantDetailsCreate />}
          />

          <Route
            path="helpsection/postings"
            element={<HelpSectionJobpostings />}
          />
          <Route
            path="helpsection/applicant"
            element={<HelpSectionApplicants />}
          />
          <Route
            path="helpsection/emailtemplates"
            element={<HelpSectionEmail />}
          />
        </Route>

        <Route element={<AuthGuard allowedRoles={systemRoles} />}>
          <Route path="applicants/list/landing" element={<ApplicantsList />} />
          <Route
            path="applicants/list/landing/:applicantId"
            element={<ApplicantsList />}
          />
          <Route
            path="applicants/create-new"
            element={<ApplicantDetailsCreate />}
          />
        </Route>

        <Route element={<AuthGuard allowedRoles={systemRoles} />}>
          <Route path="jobpostings/list/landing" element={<JobpostingList />} />
          <Route
            path="jobpostings/list/landing/:jobpostingId"
            element={<JobpostingList />}
            />
          {/* <Route
            path="jobpostings/create-new"
            element={<ApplicantDetailsCreate />}
          /> */}
        </Route>

        <Route element={<AuthGuard allowedRoles={restrictedRoles} />}>
          <Route path="jobpostings/landing" element={<JobpostingList />} />
          <Route path="jobpostings/view/:id" element={ <PostingsDetailView />} />
          {/* <Route path="jobpostings/view/:id" element={ <PostingsView />} /> */}
          {/* <Route path="jobpostings/view/:id" element={<PostingsViewNew />} /> */}
          <Route path="jobpostings/edit/:id" element={<PostingsEdit />} />
          <Route
            path="jobpostings/documents/:id"
            element={<PostingsDocuments />}
          />
          <Route
            path="jobpostings/associatedapplicants/:id"
            element={<JobpostingsAssociatedApplicantsProfile />}
          />
          <Route path="jobpostings/notes/:id" element={<PostingsNotes />} />
          <Route
            path="jobpostings/screeningquestions/:id"
            element={<JobPortal />}
          />
          <Route
            path="jobpostings/portals/view/:id"
            element={<PostingsPortalsView />}
          />
          <Route
            path="jobpostings/portals/edit/:id"
            element={<PostingsPortalsEdit />}
          />
          <Route
            path="jobpostings/auditinfo/:id"
            element={<PostingsAuditlogging />}
          />
          <Route path="jobpostings/create" element={<PostingsCreate />} />
          <Route
            path="jobpostings/create/jobdetails"
            element={<PostingsCreateTabs />}
          />
          <Route
            path="jobpostings/create/document"
            element={<PostingsCreateTabs />}
          />
          <Route
            path="jobpostings/create/questions"
            element={<PostingsCreateTabs />}
          />
          <Route
            path="jobpostings/create/portals"
            element={<PostingsCreateTabs />}
          />
          <Route
            path="jobpostings/create/recommendedTalent"
            element={<PostingsCreateTabs />}
          />
        </Route>

        <Route
          element={
            <AuthGuard allowedRoles={restrictedRoles} allowedClients={1} />
          }
        >
          <Route path="clients/landing" element={<ClientsTable />} />
          <Route path="clients/create" element={<ClientsCreate />} />
          <Route path="clients/view/:id" element={<ClientsOverview />} />
          {/* <Route path="clients/edit/:id" element={<ClientsEdit />} /> */}
          <Route path="clients/endclient/:id" element={<EndClients />} />
          <Route path="clients/jobs/:id" element={<ClientJobs />} />
          <Route
            path="clients/hiringmanagers/:id"
            element={<HiringManagers />}
          />
          <Route
            path="clients/auditinfo/:id"
            element={<ClientsAuditlogging />}
          />
        </Route>

        <Route
          element={
            <AuthGuard allowedRoles={restrictedRoles} allowedProjects={1} />
          }
        >
          <Route path="projects/landing" element={<ProjectsTable />} />
          <Route path="projects/view/:id" element={<ProjectsView />} />
          <Route path="projects/edit/:id" element={<ProjectsEdit />} />
          <Route path="projects/jobs/:id" element={<AddJobsToProjects />} />
          <Route
            path="projects/applicant/:id"
            element={<ProjectsAssociatedApplicants />}
          />
          <Route
            path="projects/auditinfo/:id"
            element={<ProjectsAuditlogging />}
          />
        </Route>
        {/* Customer */}
        <Route element={<AuthGuard allowedRoles={["Admin", "Super Admin"]} />}>
          <Route path="customer/users" element={<User />} />
          <Route path="customer/vendors" element={<VendorPortal />} />
          <Route
            path="customer/jobboardportal"
            element={<NewJobBoardPortal />}
          />
          {/* <Route path="customer/billing" element={<Billing />} /> */}
          <Route path="customer/segments" element={<Segments />} />
        </Route>
        {/* Reports - reportsEnabled required */}
        <Route
          element={
            <AuthGuard allowedRoles={restrictedRoles} requireReports={true} />
          }
        >
          <Route path="report-dashboard" element={<ReportsDashboard />} />
          <Route path="reports/dashboard" element={<ReportsDashboard />} />
          <Route path="reports/centre" element={<ReportCentre />} />
          <Route path="reports/schedulereport" element={<ScheduleReportsDashboard />} />
        </Route>
        <Route
          element={
            <AuthGuard allowedRoles={["Admin", "Super Admin", "Manager"]} />
          }
        >
          <Route path="customer/view" element={<CustomerView />} />
          <Route path="customer/custom" element={<Custom />} />
          <Route path="customer/organize/mail" element={<Mail />} />
        </Route>
      </Route>
      <Route path="/layout/404" element={<Error404 />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
    </>
  );
}

export default App;
